import { useState } from "react";
import { Button } from "primereact/button";
import { SelectButton } from "primereact/selectbutton";
import {
  genElBoolean,
  genElNumber,
} from "@components/utils/EditorDialogElementGenerator";
import KartuStokViewDialog from "../kartu-stok-view-dialog";
import FieldTextarea from "./field-textarea";
import SectionCard from "./section-card";
import SignatureRow from "./signature-row";

const signers = [
  { name: "dianalisa_oleh", label: "Dianalisa", title: "Verifikator Unit" },
];

const analisisOptions = [
  { label: "Setuju", value: 1 },
  { label: "Tolak", value: -1 },
];

// II. Analisis Kelayakan (Unit)
const SectionAnalisis = (props) => {
  const { data, setData, error, stage, saving, onSave, signProps, cardProps } = props;

  const [showKartuStok, setShowKartuStok] = useState(false);

  const disabled = stage !== "active";

  const handleOnChangeAnalisis = (value) => {
    if (value === null || value === undefined) return;

    setData((prevData) => ({
      ...prevData,
      status_analisis: value,
      // approving defaults to the volume asked, unless an amount was already typed
      ...(value === 1 && !prevData.jumlah_disetujui
        ? { jumlah_disetujui: prevData.jumlah_diminta }
        : {}),
    }));
  };

  return (
    <SectionCard
      {...cardProps}
      code="II"
      title="Analisis Kelayakan"
      role="Unit"
      stage={stage}
      saving={saving}
      onSave={onSave}
      signatures={
        <SignatureRow
          signers={signers}
          data={data}
          canSign={stage === "active" && !!data.id}
          {...signProps}
        />
      }
    >
      <KartuStokViewDialog
        visible={showKartuStok}
        onHide={() => setShowKartuStok(false)}
        department={{ id: data.department_id, ...data.data_department }}
        jenisMinyak={{ id: data.jenis_minyak_id, ...data.data_jenis_minyak }}
        tanggal={data.tanggal}
      />

      <div className="row-between-end w-100 gap-3">
        {genElBoolean({
          field: "is_cek_kartu_stok",
          name: "Kartu stok sudah dicek",
          data,
          setData,
          error,
          disabled,
        })}
        <Button
          type="button"
          icon="pi pi-search"
          rounded
          outlined
          tooltip="Lihat kartu stok bulan ini"
          tooltipOptions={{ position: "left" }}
          disabled={!data.department_id || !data.jenis_minyak_id}
          onClick={() => setShowKartuStok(true)}
        />
      </div>
      {genElBoolean({
        field: "is_cek_form_penggunaan_alat",
        name: "Form penggunaan alat sudah dicek",
        data,
        setData,
        error,
        disabled,
      })}

      <div className="col-start-start w-100 gap-1">
        <label className="font-bold text-sm text-slate-500">Hasil Analisis</label>
        <SelectButton
          value={data.status_analisis ?? null}
          options={analisisOptions}
          optionLabel="label"
          optionValue="value"
          disabled={disabled}
          onChange={(e) => handleOnChangeAnalisis(e.value)}
        />
        {error.status_analisis && (
          <small className="font-semibold text-red-400">
            {error.status_analisis}
          </small>
        )}
      </div>

      <div className="col-start-start w-100 gap-1">
        <label className="font-bold text-sm text-slate-500">
          Jumlah Diminta (Liter)
        </label>
        <span className="font-bold text-slate-600">
          {Number(data.jumlah_diminta ?? 0).toLocaleString("id-ID")}
        </span>
      </div>

      {data.status_analisis !== -1 &&
        genElNumber({
          field: "jumlah_disetujui",
          name: "Jumlah Disetujui (Liter)",
          data,
          setData,
          error,
          disabled,
          showButtons: false,
          max_fraction_digits: 2,
        })}

      {data.status_analisis === -1 && (
        <FieldTextarea
          field="alasan_penolakan"
          name="Alasan Penolakan"
          data={data}
          setData={setData}
          error={error}
          disabled={disabled}
        />
      )}
    </SectionCard>
  );
};

export default SectionAnalisis;
